/**
 * @file NewSectionFolder.jsx
 * @author Fernando Ruano
 * @description SectionFolder Page
 */

// Dependencies
import React from 'react';
import PropTypes from 'prop-types';
import { SisternodeOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

function NewSectionFolder({ onClickAction }) {
  const { t: translate } = useTranslation();
  return (
    <div
      onClick={onClickAction}
      style={{
        border: 'solid 1px var(--color-baxter-teal-medium)',
        cursor: 'pointer'
      }}
      className="mb-3 p-2 rounded-md flex flex-wrap justify-center items-center h-12">
      <SisternodeOutlined
        style={{ color: 'var(--color-baxter-teal-medium)' }}
      />
      <h3 className="text-sm text-baxterTale mb-0 ml-2">
        {translate('educationalMaterial.newSection')}
      </h3>
    </div>
  );
}

/**
 * Component definition of proptypes.
 */
NewSectionFolder.propTypes = {
  onClickAction: PropTypes.func.isRequired
};
export default NewSectionFolder;
